
import { useState, useCallback } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { TrainingFormDialog } from './TrainingFormDialog';

interface AddTrainingProps {
  variant?: 'default' | 'compact';
  isFormOpen?: boolean;
  setIsFormOpen?: (isOpen: boolean) => void;
}

export function AddTraining({
  variant = 'default',
  isFormOpen,
  setIsFormOpen
}: AddTrainingProps) {
  // Use internal state if no external state is provided
  const [internalFormOpen, setInternalFormOpen] = useState(false);
  
  // Determine which state to use
  const isOpen = isFormOpen !== undefined ? isFormOpen : internalFormOpen;
  const setIsOpen = setIsFormOpen || setInternalFormOpen;
  
  const handleSuccess = useCallback(() => {

    setTimeout(() => {

      setIsOpen(false);
    }, 10);
  }, [setIsOpen]);
  
  const handleOpenChange = useCallback((open: boolean) => {

    setIsOpen(open);
  }, [setIsOpen]);

  const handleButtonClick = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const handleCancel = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);
  
  if (variant === 'compact') {
    return (
      <>
        <Button onClick={handleButtonClick} className="w-full">
          <Plus className="h-4 w-4 mr-2" />
          Log Training
        </Button>
        
        <TrainingFormDialog 
          open={isOpen} 
          onOpenChange={handleOpenChange}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </>
    );
  }
  
  return (
    <>
      <Button onClick={handleButtonClick} size="lg" className="gap-2">
        <Plus className="h-5 w-5" />
        Log Training
      </Button>
      
      <TrainingFormDialog 
        open={isOpen} 
        onOpenChange={handleOpenChange}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </>
  );
}
